import { loggedIn, requiresEvidence, invoiceNeedsPaying } from '../../../routes/conditional';
import { getEvidenceGetURL } from '../../../redux/modules/checkout';
import { getCheckoutOrderId } from '../../../redux/modules/root-reducer';
import paths from '../../../routes/paths';

// eslint-disable-next-line import/prefer-default-export
export const page = {
  path: paths.checkout.viewEvidence,
  isAllowed: [loggedIn, invoiceNeedsPaying, requiresEvidence],
  action: ({ state }) => getEvidenceGetURL(getCheckoutOrderId(state)),
};
